var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHabitsLateNight = function SvgHabitsLateNight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce85",
    d: "M11.954 2.615c12.298 3.454 21.977 13.133 25.431 25.431L2.706 37.294l9.248-34.679z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#967a44",
    d: "M12.305 3.237c11.738 3.475 20.983 12.72 24.458 24.458L3.411 36.589l8.894-33.352M11.6 2 2 38l36-9.6C34.575 15.532 24.468 5.425 11.6 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M23.5 38.498c-1.103 0-2-.897-2-2v-1.024a2.453 2.453 0 0 0-3.059-2.375l-.123.033A2.456 2.456 0 0 0 16.5 35.5v.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5a1.218 1.218 0 0 0-1.52-1.178l-9.274 2.473 8.17-30.64c11.21 4.108 18.969 11.86 22.486 22.465l-5.748 1.533a2.848 2.848 0 0 0-2.114 2.75v3.096a2.002 2.002 0 0 1-2 1.999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#967a44",
    d: "M11.217 7.316c10.609 4.033 18.011 11.422 21.499 21.458l-4.432 1.183-.798.212A3.35 3.35 0 0 0 25 33.402v3.096c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-1.025a2.954 2.954 0 0 0-3.694-2.857l-.119.032A2.959 2.959 0 0 0 16 35.5v.5c0 .551-.449 1-1 1s-1-.449-1-1a1.719 1.719 0 0 0-2.155-1.66l-1.66.443-.008.002-1.723.46-5.043 1.345 7.806-29.274M10.533 6 2 38l6.712-1.79-.001.002 1.733-.464 1.659-.442A.718.718 0 0 1 13 36a2 2 0 1 0 4 0v-.5c0-.884.594-1.657 1.447-1.886l.117-.031A1.953 1.953 0 0 1 21 35.473v1.025a2.5 2.5 0 1 0 5 0v-3.096c0-1.063.716-1.994 1.743-2.267l.798-.212v-.001L34 29.467C30.219 17.52 21.479 9.868 10.533 6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M22 22.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 1 0 0-7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M22 23c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m0-1a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f78f8f",
    d: "M8.5 24.5a3 3 0 1 0 0 6 3 3 0 1 0 0-6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#c74343",
    d: "M8.5 25c1.378 0 2.5 1.122 2.5 2.5S9.878 30 8.5 30 6 28.878 6 27.5 7.122 25 8.5 25m0-1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0c1d4",
    d: "M15 13.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 1 0 0-5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#66798f",
    d: "M15 14c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2m0-1a3 3 0 1 0 0 6 3 3 0 0 0 0-6"
  })));
};
export default SvgHabitsLateNight;